import { MODULE_TRANSLATIONS } from '../modules/index.ts';
import en from './en.json';
import ptBR from './pt-BR.json';

/**
 * Os textos de tela: os da base e, debaixo da chave com o id, os de cada módulo instalado
 * (ADR 0123). Os testes leem daqui para conferir os textos dos módulos também.
 */
export const TRANSLATIONS = {
  'pt-BR': { ...ptBR, ...MODULE_TRANSLATIONS['pt-BR'] },
  en: { ...en, ...MODULE_TRANSLATIONS.en },
};
